import { api } from './client.js';
import { chatApi } from './chat.js';

const root = '/kiosk';

export const kioskApi = {
  stores: () => api.get(`${root}/stores`),
  grant: (body) => api.post(`${root}/consent`, body),
  status: (sid) => api.get(`${root}/consent/${sid}`),
  revoke: (sid, reason) => api.post(`${root}/consent/revoke`, { customerSessionId: sid, reason }),

  /**
   * Streaming chat for the anonymous kiosk visitor. Reuses the shared SSE
   * transport but tags the request with the customer session header so the
   * server can enforce consent and bind the turn to the right store.
   */
  chatStream: (body, { customerSessionId, ...opts } = {}) => chatApi.chatStream(body, {
    ...opts,
    headers: { ...(opts.headers || {}), 'X-Customer-Session': customerSessionId }
  }),

  /**
   * Self-registration submitted from the in-store registration widget. Tagged
   * with the customer session header so the server binds it to the right store
   * and enforces the active consent.
   */
  register: (body, { customerSessionId } = {}) => api.post(`${root}/register`, body, {
    headers: { 'X-Customer-Session': customerSessionId }
  })
};
